import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { TextField, FormControl, InputLabel } from "@mui/material";
import { path } from "ramda";

const getPath = name => name.split(".");

// https://material-ui.com/api/text-field/
const TextInput = ({ customMargin, label, name, color, ...rest }) => {
  const { values, handleBlur, handleChange, errors, touched } =
    useFormikContext();
  const namePath = getPath(name);
  const error = path(namePath, touched) && path(namePath, errors);
  const value = path(namePath, values);
  return (
    <FormControl
      fullWidth
      error={!!error}
      style={{ margin: 3, borderColor: "#337abb" }}
    >
      <InputLabel
        shrink={true}
        id={`${name}-label`}
        style={{
          fontSize: "1.25rem",
          lineHeight: 1.5,
          marginLeft: customMargin ? customMargin : -10,
          color: "rgba(0, 0, 0, 0.87)",
          width: "100%",
          whiteSpace: "normal",
          wordBreak: "break-word"
        }}
      >
        {label}
      </InputLabel>
      <TextField
        id={name}
        error={!!error}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={error}
        margin="dense"
        style={{ width: "100%", marginTop: "20px" }}
        color={color ?? "primary"}
        aria-labelledby={`${name}-label`}
        {...rest}
      />
    </FormControl>
  );
};

TextInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default TextInput;
